import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import Creche from '../../../components/educacao/documentos/creche';
import ItemBox from '../../../components/shared/item_box';


function CrecheScreen() {
    return (
        <Fragment>
            <Head titulo="Cadastro Único da Creche Municipal" />
            <Header />
            <Container>
                <ItemBox
                    titulo={"Documentos Necessários"}
                    texto={<Fragment><p>Confira no link abaixo os documentos necessários para matricular uma criança na Creche Municipal Zilda Ribeiro Bianchini</p><br /></Fragment>}
                    link={"../arquivos/sme/docscreche.pdf"}
                />
                <br />
                <ItemBox
                    titulo={"Critérios para inscrições das crianças - Lei Municipal nº 781"}
                    texto={<Fragment><p>Confira no link abaixo os critérios para inscrições das crianças tal como a priorização de acesso para elas.</p><br /></Fragment>}
                    link={"https://prefeituramacuco.rj.gov.br/transparencia/arquivos/lei/2017/Lei781.pdf"}
                />
                <br />
                <Creche /><br /><br />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CrecheScreen;